import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';
import {
    getPayoutBatch,
    getIsPayoutBatchLoading,
    getPayoutBatchErrorMessage,
    getIsRejectLoading,
    getRejectErrorMessage,
    getIsApproveLoading,
    getApproveErrorMessage,
    getIsRejectSuccess,
    getIsApproveSuccess
} from './payoutBatchEntity';
import { getPayoutBatch as queryForPayoutBatch } from './payoutBatchActions';
import { selectPendingPayoutsFromBatches } from '../PendingPayouts/pendingPayoutsActions';
import { selectPayoutFromBatches } from '../Payouts/payoutsActions';

import {
    EmvioCard,
    EmvioLoadingSpinner as LoadingSpinner,
    EmvioRow,
    EmvioTwoColumnItem
} from '@nexio/emvio-util-ui';
import { payoutBatchShape, historyShape } from '../../utils/propTypes';
import {
    doesPropExistAndHasItChanged,
    payoutProviderMapper,
    prettifyMoney,
    currency
} from '@nexio/emvio-util-app';
import { prettifyDate } from '../../utils/string';
import { toastIfError } from '../../utils/toast';
import ErrorCard from '../ErrorCard/ErrorCard';
import mixpanel from '../../utils/mixpanel';
import './PayoutBatch.scss';
import { getPayoutAccountsMapper } from '../PayoutAccounts/payoutAccountEntity';
import { EmvioButton } from '@nexio/emvio-form-components';
import { toggleModal } from '../Modal/modalActions';
import { approvePayoutBatch } from './payoutBatchActions';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { getPayoutBatchReference, getFailedPayoutBatch } from '../Search/searchActions';
import { selectErroredPayout } from '../Payouts/ErroredPayouts/erroredPayoutsActions';

export class PayoutBatch extends Component {
    static propTypes = {
        batchError: PropTypes.string,
        rejectError: PropTypes.string,
        approveError: PropTypes.string,
        isPayoutBatchLoading: PropTypes.bool,
        isRejectBatchLoading: PropTypes.bool,
        isApproveBatchLoading: PropTypes.bool,
        isApproveSuccess: PropTypes.bool,
        isRejectSuccess: PropTypes.bool,
        match: PropTypes.shape({
            isExact: PropTypes.bool,
            params: PropTypes.shape({
                id: PropTypes.string
            }),
            path: PropTypes.string,
            url: PropTypes.string
        }),
        onGetPayoutBatchById: PropTypes.func,
        onGoBack: PropTypes.func,
        payoutBatch: payoutBatchShape,
        onToggleModal: PropTypes.func.isRequired,
        approveBatch: PropTypes.func.isRequired,
        customAccess: PropTypes.any,
        payoutAccountMap: PropTypes.any,
        providerType: PropTypes.func,
        toUpperCase: PropTypes.func,
        history: historyShape,
        onSelectPayout: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {
        this.props.onGetPayoutBatchById(this.props.match.params.id);
        mixpanel.track('PayoutBatch page mounted');
    }

    componentDidUpdate(prevProps) {
        toastIfError(prevProps, this.props, 'batchError');
        toastIfError(prevProps, this.props, 'rejectError');
        toastIfError(prevProps, this.props, 'approveError');

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'match.params.id')) {
            this.props.onGetPayoutBatchById(this.props.match.params.id);
        }

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'isApproveSuccess') && this.props.isApproveSuccess) {
            this.props.onGetPayoutBatchById(this.props.match.params.id);
            toast('Batch Approval Successful', { type: 'success' });
        }

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'isRejectSuccess') && this.props.isRejectSuccess) {
            this.props.onGetPayoutBatchById(this.props.match.params.id);
            toast('Batch Rejection Successful', { type: 'success' });
        }
    }

    handleApproveBatchButton = () => {
        this.props.approveBatch(_.get(this.props.payoutBatch, 'id'));
    };

    renderPayoutBatchSummary = () => {
        const { batchProcessingStatus } = this.props.payoutBatch;
        const items = [
            {
                label: 'Batch Processing Status',
                value: batchProcessingStatus
            }
        ];

        if (batchProcessingStatus !== 'CANCELED') {
            items.unshift(
                {
                    label: 'Payout Count',
                    value: _.get(this.props.payoutBatch, 'payoutCount')
                },
                {
                    label: 'Processed Payout Count',
                    value: _.get(this.props.payoutBatch, 'processedPayoutCount')
                },
                {
                    alterMethod: this.renderFailedPayoutBatch,
                    label: 'Failed Payout Count',
                    value: _.get(this.props, 'payoutBatch')
                },
                {
                    alterMethod: this.renderErroredPayoutBatch,
                    label: 'Errored Payout Count',
                    value: _.get(this.props, 'payoutBatch')
                }
            );
        }

        return this.renderCard(items, 'Batch Summary');
    };

    renderFailedPayoutBatch(value) {
        if (value.failedPayoutCount > 0) {
            return <Link className="batch-clickthrough-link"
                to={getFailedPayoutBatch(value.batchRef)}>{value.failedPayoutCount}</Link>;
        } else {
            return <span className="batch-clickthrough-non-link">{value.failedPayoutCount}</span>;
        }
    }

    renderErroredPayoutBatch(value) {
        if (value.badPayoutRequestCount > 0) {
            return <Link className="batch-clickthrough-link"
                to={selectErroredPayout(value.batchRef)}>{value.badPayoutRequestCount}</Link>;
        } else {
            return <span className="batch-clickthrough-non-link">{value.badPayoutRequestCount}</span>;
        }
    }

    renderBatchInfo = () => {
        const items = [
            {
                label: 'Batch ID',
                value: _.get(this.props.payoutBatch, 'id')
            },
            {
                alterMethod: this.renderBatchReference,
                label: 'Batch Reference',
                value: _.get(this.props.payoutBatch, 'batchRef')
            },
            {
                label: 'Time Submitted',
                value: _.get(this.props.payoutBatch, 'createdAt'),
                alterMethod: ((createdAt) => prettifyDate(createdAt))
            },
            {
                label: 'Time Completed',
                value: (_.get(this.props.payoutBatch, 'batchProcessingStatus') === 'COMPLETE' ? _.get(this.props.payoutBatch, 'updatedAt') : null),
                alterMethod: ((updatedAt) => prettifyDate(updatedAt))
            }
        ];

        return this.renderCard(items, 'Batch Information');
    };

    renderBatchReference = () => {
        const { batchRef, initialBatchDate, updatedAt } = this.props.payoutBatch;

        const endDate = moment(updatedAt).format('YYYY-MM-DD');

        return <Link className="batch-clickthrough-link" to={getPayoutBatchReference(batchRef, initialBatchDate, endDate)}>{batchRef}</Link>;
    };

    handleRejectModal = (e) => {
        e.preventDefault();
        this.props.onToggleModal();
    };

    renderApproveAndRejectButtons = () => {
        const { batchProcessingStatus } = this.props.payoutBatch;

        if (batchProcessingStatus === 'REVIEW') {
            return (
                <div className="emvio-payout-buttons">
                    <EmvioButton
                        type="button"
                        className="reject-button"
                        onClick={this.handleRejectModal}
                    >
                        Reject
                    </EmvioButton>
                    <EmvioButton
                        type="button"
                        className="approve-button"
                        onClick={this.handleApproveBatchButton}
                    >
                        {_.get(this.props, 'isApproveBatchLoading') ? 'Loading...' : 'Approve'}
                    </EmvioButton>
                </div>
            );
        } else {
            return null;
        }
    };

    mapProviderName = (providerType) => {
        return payoutProviderMapper[`${providerType}`].toUpperCase();
    };

    handleClickRow = (providerId, currency, batchRef, batchProcessingStatus) => {
        switch (batchProcessingStatus) {
            case 'REVIEW':
            case 'PENDING_REVIEW':
                return selectPendingPayoutsFromBatches(this.props.history, providerId, currency.toLowerCase(), batchRef);
            case 'COMPLETE':
            case 'RUNNING':
                return selectPayoutFromBatches(this.props.history, providerId, currency.toLowerCase(), batchRef);
            case 'CANCELED':
                break;
            default:
                break;
        }
    };

    getCurrencySymbol = (providerCurrency) => {
        return _.get(currency, `${providerCurrency.toLowerCase()}`).symbol;
    };

    renderCard(items, headerTitle) {
        return (
            <EmvioCard className="half-width grow-height" HeaderComponent={headerTitle}>
                {items.map((item) =>
                    <EmvioTwoColumnItem
                        key={item.label}
                        alterMethod={item.alterMethod}
                        label={item.label}
                        value={item.value}
                        breakAll={item.breakAll}
                    />
                )}
            </EmvioCard>);
    }

    renderSummaryFooter() {
        const { batchProcessingStatus } = this.props.payoutBatch;

        const currencyTotals = {};

        this.props.payoutBatch.batchDetails.forEach((item) => {
            const amount = batchProcessingStatus === 'REVIEW' || batchProcessingStatus === 'PENDING_REVIEW' ? item.reviewAmount : item.processedAmount;

            if (currencyTotals[`${item.currency}`]) {
                currencyTotals[`${item.currency}`] += amount;
            } else {
                currencyTotals[`${item.currency}`] = amount;
            }
        });

        let currencyTotalsArray = Object.entries(currencyTotals).sort();

        return (
            <div className="provider-summary-footer">
                <div className="emvio-card-header-wrapper">Payout Totals</div>
                <div className="provider-currencies-wrapper">
                    {currencyTotalsArray.map((ct) =>
                        <div className={`emvio-card-header-wrapper provider-currency-totals curr-${ct[0]}`} key={ct[0]}>
                            <span
                                id="provider-summary-currency">{`TOTAL ${this.getCurrencySymbol(ct[0])} ${ct[0].toUpperCase()}`}</span>
                            <span id="provider-summary-amount">{prettifyMoney(ct[1]).slice(1)}</span>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    renderProviderSummary = () => {
        const { payoutBatch } = this.props;

        if (_.isEmpty(payoutBatch.batchDetails)) {
            return null;
        }

        return (
            <EmvioCard className="grow-height" HeaderComponent="Provider Summary">
                <table className="provider-summary-table">
                    <thead>
                        <tr>
                            <td className="payout-batch-table-currency">CURRENCY</td>
                            <td className="payout-batch-table-amount">AMOUNT</td>
                            <td className="payout-batch-table-provider">PAYOUT PROVIDER NAME</td>
                            {payoutBatch.batchProcessingStatus === 'REVIEW' || payoutBatch.batchProcessingStatus === 'PENDING_REVIEW'
                                ? <td className="payout-batch-table-count">PENDING PAYOUTS</td>
                                : null
                            }
                            <td className="payout-batch-table-count">SUCCESSFUL PAYOUTS</td>
                            <td className="payout-batch-table-count">FAILED PAYOUTS</td>
                            <td className="payout-batch-table-provider-id">PAYOUT PROVIDER ID</td>
                            <td className="payout-batch-table-status">PAYOUT STATUS</td>
                        </tr>
                    </thead>
                    <tbody>
                        {payoutBatch.batchDetails.map((item) =>
                            <tr className={payoutBatch.batchProcessingStatus === 'CANCELED' ? '' : 'batch-row'}
                                key={item.id}
                                onClick={() => {
                                    this.handleClickRow(item.providerId, item.currency, payoutBatch.batchRef, payoutBatch.batchProcessingStatus);
                                }}
                            >
                                <td className="payout-batch-table-currency">{this.getCurrencySymbol(item.currency)} {item.currency.toUpperCase()}</td>
                                <td className="payout-batch-table-amount">
                                    {payoutBatch.batchProcessingStatus === 'REVIEW' || payoutBatch.batchProcessingStatus === 'CANCELED'
                                        ? prettifyMoney(item.reviewAmount, item.currency)
                                        : prettifyMoney(item.processedAmount, item.currency)
                                    }
                                </td>
                                <td className="payout-batch-table-provider"
                                    id="payout-provider-type">{this.mapProviderName(item.providerType)}</td>
                                {payoutBatch.batchProcessingStatus === 'REVIEW'
                                    ? <td className="payout-batch-table-count">{item.reviewCount}</td>
                                    : null
                                }
                                <td className="payout-batch-table-count"
                                    id="provider-total-count">{item.processedCount}</td>
                                <td className="payout-batch-table-count"
                                    id="provider-total-count">{item.failedCount}</td>
                                <td className="payout-batch-table-provider-id">{item.providerId}</td>
                                <td className="payout-batch-table-status">{payoutBatch.batchProcessingStatus}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
                {this.renderSummaryFooter()}
                {this.renderApproveAndRejectButtons()}
            </EmvioCard>
        );
    };

    render() {
        const { isPayoutBatchLoading, payoutBatch, payoutAccountMap, batchError } = this.props;

        if (isPayoutBatchLoading) {
            return (<LoadingSpinner />);
        } else if (payoutBatch && payoutAccountMap && !batchError) {
            return (
                <div className="emvio-payout-batch">
                    <EmvioRow>
                        {this.renderPayoutBatchSummary()}
                        {this.renderBatchInfo()}
                    </EmvioRow>
                    <EmvioRow>
                        {this.renderProviderSummary()}
                    </EmvioRow>
                </div>
            );
        } else {
            return (
                <div className="emvio-payout-batch">
                    <EmvioRow>
                        <ErrorCard />
                    </EmvioRow>
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    return {
        batchError: getPayoutBatchErrorMessage(state),
        isPayoutBatchLoading: getIsPayoutBatchLoading(state),
        payoutBatch: getPayoutBatch(state),
        payoutAccountMap: getPayoutAccountsMapper(state),
        isRejectBatchLoading: getIsRejectLoading(state),
        rejectError: getRejectErrorMessage(state),
        isApproveBatchLoading: getIsApproveLoading(state),
        approveError: getApproveErrorMessage(state),
        isApproveSuccess: getIsApproveSuccess(state),
        isRejectSuccess: getIsRejectSuccess(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onGetPayoutBatchById: (id) => dispatch(queryForPayoutBatch(id)),
        onToggleModal: () => dispatch(toggleModal('rejectBatch')),
        approveBatch: (batchId) => dispatch(approvePayoutBatch(batchId))
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PayoutBatch));
